/* eslint-disable import/no-cycle */
import React from "react";

import moment from "moment";

import CurrencyFormat from "react-currency-format";
import ButtonComponent from "../button";

import { InvoiceModel } from "../../../domain/models/invoice";

import { theme } from "../../styles/theme";
import {
  LabelStyled,
  RowStyled,
  SectionStyled,
  Title,
  ValueStyled,
  Wrapper,
} from "./styled";

type PageProps = {
  invoice: InvoiceModel | any | undefined;
  onConfirmCallback?: () => void;
  onCancelCallback?: () => void;
};

const isSmallScreen = window.innerWidth < 768;

const ResumeInvoice: React.FC<PageProps> = ({
  invoice,
  onConfirmCallback,
  onCancelCallback,
}) => (
  <Wrapper>
    <SectionStyled>
      <Title>Dados da Empresa:</Title>
      <RowStyled>
        <LabelStyled>Razão Social/Nome:</LabelStyled>
        <ValueStyled style={{ width: isSmallScreen ? "100%" : "" }}>
          {invoice?.companyName}
        </ValueStyled>
      </RowStyled>
      <RowStyled>
        <LabelStyled>Endereço:</LabelStyled>
        <ValueStyled
          style={{ width: isSmallScreen ? "100%" : "" }}
        >{`${invoice?.address}`}</ValueStyled>
      </RowStyled>

      <RowStyled style={{ maxWidth: "100%" }}>
        <RowStyled style={{ width: "50%" }}>
          <LabelStyled>Município:</LabelStyled>
          <ValueStyled>{invoice?.city}</ValueStyled>
        </RowStyled>
        <RowStyled style={{ width: "25%", marginLeft: isSmallScreen ? 0 : 10 }}>
          <LabelStyled>UF:</LabelStyled>
          <ValueStyled>{invoice?.state}</ValueStyled>
        </RowStyled>
        <RowStyled style={{ width: "25%", marginLeft: isSmallScreen ? 0 : 10 }}>
          <LabelStyled>País:</LabelStyled>
          <ValueStyled>{invoice?.country?.name}</ValueStyled>
        </RowStyled>
      </RowStyled>
    </SectionStyled>

    <SectionStyled>
      <Title>Descrição dos Serviços:</Title>
      <RowStyled>
        <ValueStyled className="p-3 w-100">{`${invoice?.description}`}</ValueStyled>
      </RowStyled>
      <RowStyled className="" style={{ width: isSmallScreen ? "50%" : "30%" }}>
        <LabelStyled>Data:</LabelStyled>
        <ValueStyled>{`${moment(invoice?.date).format(
          "DD/MM/YYYY",
        )}`}</ValueStyled>
      </RowStyled>
    </SectionStyled>
    <SectionStyled>
      <Title>Valores:</Title>
      <RowStyled style={{ width: "100%" }}>
        <RowStyled style={{ width: "70%" }}>
          <LabelStyled className="w-100 d-flex">Valor do Serviço:</LabelStyled>
          <ValueStyled>
            <CurrencyFormat
              value={invoice?.serviceValue
                ?.replaceAll(".", "")
                .replaceAll(",", ".")}
              thousandSeparator={false}
              prefix={invoice?.currency?.split(" - ")[2]}
              displayType="text"
            />
          </ValueStyled>
        </RowStyled>
        <RowStyled style={{ width: "30%", marginLeft: isSmallScreen ? 0 : 10 }}>
          <LabelStyled>Moeda:</LabelStyled>
          <ValueStyled>{`${invoice?.currency?.split(" - ")[0]}`}</ValueStyled>
        </RowStyled>
      </RowStyled>
    </SectionStyled>
    <SectionStyled>
      <Title>Dados Bancários:</Title>
      <RowStyled style={{ width: "50%" }}>
        <LabelStyled>Banco:</LabelStyled>
        <ValueStyled>{invoice?.bankName}</ValueStyled>
      </RowStyled>
      <RowStyled style={{ width: "100%" }}>
        <RowStyled style={{ width: "25%" }}>
          <LabelStyled>Agência:</LabelStyled>
          <ValueStyled>{invoice?.bankAgency}</ValueStyled>
        </RowStyled>
        <RowStyled style={{ width: "30%" }}>
          <LabelStyled>Conta:</LabelStyled>
          <ValueStyled>{invoice?.bankAccount}</ValueStyled>
        </RowStyled>
        <RowStyled style={{ width: "20%" }}>
          <LabelStyled>Dígito:</LabelStyled>
          <ValueStyled>{invoice?.bankDigit}</ValueStyled>
        </RowStyled>
      </RowStyled>
    </SectionStyled>
    <div className="d-flex justify-content-center mt-4">
      <div className="ms-3">
        <ButtonComponent
          title="Cancelar"
          backgroundColor={theme.colors.darkBlue}
          color={theme.colors.white}
          onClick={onCancelCallback}
        />
      </div>
      <div className="me-3">
        <ButtonComponent
          title="Confirmar e Gerar Invoice"
          backgroundColor={theme.colors.blue400}
          color={theme.colors.darkBlue}
          onClick={onConfirmCallback}
        />
      </div>
    </div>
  </Wrapper>
);

export default ResumeInvoice;
